import React, { useEffect, useState } from 'react';
import CuadroDatos from '../../UI/CuadroDatos.js';
import TablaDatos from '../../UI/TablaDatos.js';
import { NombreClub } from '../../funciones/FuncionesClub.js';
import { OrdenarListaFechaDesc } from '../../funciones/FuncionesTorneos.js';
import useGetListaURL from '../../../hooks/useGetListaURL.js';
import styles from './CuadroHonorInt.module.css';

const CuadroHonorInt = (props) => {
  const tipoTorneo = props.tipoTorneo;
  const categoria = props.categoria;
  const [campeones, setCampeones] = useState([]);
  const { isCargando, erroresGetLista, fetchData, resetErroresGetLista } = useGetListaURL();

  useEffect(() => {
    resetErroresGetLista();
  }, [resetErroresGetLista]);

  useEffect(() => {
    const ordenarTorneos = (lista) => {
      const listaFiltrada = lista.filter((item) => item.fechaFin !== null);
      if (listaFiltrada) {
        setCampeones(OrdenarListaFechaDesc(listaFiltrada));
      } else {
        setCampeones([]);
      }
    };

    if (tipoTorneo) {
      let URL = 'tipos_torneo/' + tipoTorneo.codigo + '/cuadro_honor';
      if (categoria) {
        URL += '?categoria=' + categoria.codigo;
      }
      fetchData(URL, ordenarTorneos);
    } else {
      setCampeones([]);
    }
  }, [tipoTorneo, categoria, fetchData]);

  return (
    <div className={`${styles.cuadro}`}>
      <CuadroDatos
        titulo={'Cuadro de Honor'}
        mostrar={true}
        isCargando={isCargando}
        error={erroresGetLista}
      >
        <TablaDatos
          estilo={`${styles.tablaDatos}`}
          lista={campeones}
          textoVacia="No hay datos a mostrar"
        >
          <tbody>
            <tr className={`${styles.titulos}`} key="0">
              <td className={`${styles.nombre}`}></td>
              <td className={`${styles.cantidad}`}>Títulos</td>
            </tr>
            {campeones &&
              campeones.map((item) => (
                <tr className={`${styles.valores}`} key={item.id}>
                  <td className={`${styles.nombre}`}>{NombreClub(item)}</td>
                  <td className={`${styles.cantidad}`}>{item.total}</td>
                </tr>
              ))}
          </tbody>
        </TablaDatos>
      </CuadroDatos>
    </div>
  );
};

export default CuadroHonorInt;
